import { render, staticRenderFns } from "./_TalentEmblem.vue?vue&type=template&id=2d2a36a9&scoped=true&"
import script from "./_TalentEmblem.vue?vue&type=script&lang=ts&"
export * from "./_TalentEmblem.vue?vue&type=script&lang=ts&"
import style0 from "./_TalentEmblem.vue?vue&type=style&index=0&id=2d2a36a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a36a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
